import React, {Component} from "react";
import compose from "lodash/flowRight";
import {graphql, withApollo} from "react-apollo";
import {connect} from "react-redux";
import gql from "graphql-tag";

import {Box, Spinner} from "@unibuddy/patron";
import universityFragment from "shared/University/fragments/universityFragment";
import AnalyticsValue from "shared/AnalyticsNew/AnalyticsValue/AnalyticsValue";
import withIdentify from "shared/Auth/withIdentify";
import withAnalytics from "shared/AnalyticsNew/withAnalytics/withAnalytics";
import {productSpec} from "shared/AnalyticsNew/constants/productSpecification";
import VisuallyHidden from "shared/Experimental/A11y/components/VisuallyHidden/VisuallyHidden";
import {SkipNavLink} from "shared/Experimental/A11y/components/SkipNav/SkipNav";

import {withTranslation, Constants} from "@unibuddy/intl";
import s from "./ProspectWidget.pcss";
import ProspectWidgetRoutes from "./ProspectWidgetRoutes";
import HeaderTabs from "../../../modules/HeaderBar/containers/HeaderTabs/HeaderTabs";
import {AppContainer} from "../../../shared/components/Containers/AppContainer";
import {ContentContainer} from "../../../shared/components/Containers/ContentContainer";
import {FooterContainer} from "../../../shared/components/Containers/FooterContainer";

const GetUniversityQuery = gql`
    query GetUniversityQuery($slug: String) {
        university(slug: $slug) {
            ...UniversityFull
            mentorMessagesCount
        }
    }
    ${universityFragment}
`;

export class ProspectWidgetComponent extends Component {
    componentDidMount() {
        // Record Product Opened Event
        this.props.analytics.events.productOpened({
            name: productSpec.embeddedUniversityWidget.NAME,
            universitySlug: this.props.match.params.universitySlug,
            ubLang: this.props?.i18n?.language ?? Constants.DEFAULT_LOCALE,
        });
    }

    render() {
        if (this.props.loading) {
            return (
                <AppContainer>
                    <ContentContainer>
                        <Box
                            padding="medium"
                            display="flex"
                            alignItems="center"
                            justifyContent="center"
                            h="100%"
                            flex="1"
                        >
                            <Box>
                                <Spinner />
                            </Box>
                        </Box>
                    </ContentContainer>
                </AppContainer>
            );
        }

        return (
            <AppContainer id="jigglypuff">
                <AnalyticsValue
                    name={productSpec.embeddedUniversityWidget.properties.UNIVERSITY_SLUG}
                    value={this.props.match.params.universitySlug}
                />
                <AnalyticsValue
                    name={productSpec.embeddedUniversityWidget.properties.PRODUCT}
                    value={productSpec.embeddedUniversityWidget.NAME}
                />
                <SkipNavLink contentId={"content"} />
                <HeaderTabs
                    universitySlug={this.props.match.params.universitySlug}
                    primaryApp="university-jigglypuff"
                    {...this.props}
                />
                <ContentContainer>
                    <ProspectWidgetRoutes
                        university={this.props.university}
                        universitySlug={this.props.match.params.universitySlug}
                        primaryApp="university-jigglypuff"
                        {...this.props}
                    />
                </ContentContainer>
                <FooterContainer>
                    <div className={s.footer} role={"contentinfo"}>
                        <a
                            href="https://www.unibuddy.co/accessibility-policy"
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                            {this.props.t("accessibilityPolicy", "Unibuddy Accessibility Policy")}
                            <VisuallyHidden>
                                {`, ${this.props.t("opensInANewWindow", "Opens in a new window")}`}
                            </VisuallyHidden>
                        </a>
                    </div>
                </FooterContainer>
            </AppContainer>
        );
    }
}

const universityQueryOptions = {
    name: "universityQuery",
    // options for the initial query
    options(props) {
        return {
            variables: {
                slug: props.match.params.universitySlug,
            },
            fetchPolicy: "cache-and-network",
        };
    },
    // convert the ugly apollo results into custom props
    props({universityQuery: {loading, university}}) {
        return {
            university,
            loading,
        };
    },
};

const mapStateToProps = (state) => ({
    appState: state.appState,
});

export default compose(
    connect(mapStateToProps),
    withApollo,
    withIdentify,
    withTranslation("common"),
    withAnalytics,
    graphql(GetUniversityQuery, universityQueryOptions),
)(ProspectWidgetComponent);
